import { render, staticRenderFns } from "./addnav.vue?vue&type=template&id=039585b9&scoped=true"
import script from "./addnav.vue?vue&type=script&lang=js"
export * from "./addnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039585b9",
  null
  
)

export default component.exports